"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundToDecimalPlace = void 0;
/**
 * Rounds a float up or down to the requested decimal place.
 *
 * @param {number} float
 * @returns {string}
 */
var roundToDecimalPlace = function roundToDecimalPlace(float, decimalPlaces) {
  var roundedVal = typeof float === 'number' ? float.toFixed(decimalPlaces) : '0';
  return roundedVal;
};
exports.roundToDecimalPlace = roundToDecimalPlace;